import { Button } from '@chakra-ui/react';
import React from 'react';
import { useParams } from 'react-router-dom';
import ConfirmationModal from '../../../shared/components/ConfirmationModal';
import useStore from '../../../shared/store';

function DeleteCampaignModal() {
  const { screenId } = useParams();
  const { deleteCampaign, setDeleteCampaign } = useStore((state) => state.api);
  const { currentId } = useStore((state) => state.campaigns.deletion);
  const isLoading = useStore((state) => state.campaigns.deleteCampaign.isLoading);

  const onClose = () => setDeleteCampaign(null);

  const handleDelete = async () => {
    await deleteCampaign(currentId!, screenId);

    setDeleteCampaign(null);
    onClose();
  };

  return (
    <ConfirmationModal isOpen={!!currentId} onClose={onClose} isCancelDisabled={isLoading}>
      <Button
        onClick={handleDelete}
        variant="solid"
        colorScheme="primary"
        isLoading={isLoading}
        disabled={isLoading}
      >
        Excluir
      </Button>
    </ConfirmationModal>
  );
}

export default DeleteCampaignModal;
